import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PassengerNameModule } from '@common/pipes';
import { TextTooltipModule } from '@lib/components';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';
import { LoungeCatalogeComponent } from './lounge-cataloge/lounge-cataloge.component';
import { LoungeServiceRequestComponent } from './lounge-service-request.component';
import { LoungeServiceRequestHeaderComponent } from './lounge-service-request-header.component';
import { LoungeServiceRequestFooterComponent } from './lounge-service-request-footer.component';

@NgModule({
  declarations: [
    LoungeServiceRequestComponent,
    LoungeCatalogeComponent,
    LoungeServiceRequestHeaderComponent,
    LoungeServiceRequestFooterComponent,
  ],
  imports: [CommonModule, AmountFormatModule, StaticMsgModule, TextTooltipModule, PassengerNameModule],
})
export class LoungeServiceRequestModule {}
